import type { GetIndicatorResultsByIndicatorIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetIndicatorResultsByIndicatorIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetIndicatorResultsByIndicatorIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetIndicatorResultsByIndicatorIdArgs = {
  indicatorId: string;
};

export const useLazyGetIndicatorResultsByIndicatorId = createLazyQueryHook<
  UseLazyGetIndicatorResultsByIndicatorIdArgs,
  GetIndicatorResultsByIndicatorIdResponseRow[],
  GetIndicatorResultsByIndicatorIdQuery
>({
  trpcQuery: (client, { indicatorId }) =>
    client.frontend.indicator.indicatorResultsByIndicatorId.query({
      indicatorId,
    }),
  mapTrpcDataToGraphQL: (data) => ({ indicator_result: data ?? [] }),
  graphqlDocument: GetIndicatorResultsByIndicatorIdDocument,
  graphqlVariables: ({ indicatorId }) => ({ indicatorId }),
  graphqlFetchPolicy: 'no-cache',
});
